import React, {useEffect} from "react";
import {authAPI} from "../../../api/auth/authAPI"

export default function TokenPage() {

    useEffect(() => {

        
        debugger;
        //const code = window.location.search.substr(3);
        const code = window.location.search.substr(7);
        
        console.log("TOKEN PAGE " + code);
        
        window.sessionStorage.setItem('code', code);

        debugger;

        //const { code } = getParameterByName('SAMLResponse');

        
         if (!code){
             window.sessionStorage.removeItem('user');
             window.location.href = "/authorize";

         }

        authAPI.getToken('token' + code, (data) => {
            debugger;

            window.sessionStorage.removeItem('user');
            window.sessionStorage.setItem('user', JSON.stringify(data));

            window.location.href = window.sessionStorage.getItem("ingressPath") || "/";
        });

    }, []);

    return (
        <>
            <div className="loading-container"></div>
            <div className="loading-widget"><div className="loading-img"></div></div>
        </>
    );
}
